import { LOGOUT_NAVBAR } from "./actionTypes";

export default () => ({
  type: LOGOUT_NAVBAR,
  payload: {

  }
});